export default __webpack_public_path__ + "static/media/thand1.135f529d.png";